import script from "./AcceptCookies.vue?vue&type=script&setup=true&lang=ts"
export * from "./AcceptCookies.vue?vue&type=script&setup=true&lang=ts"

import "./AcceptCookies.vue?vue&type=style&index=0&id=1aa79596&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa79596"]])

export default __exports__